module.exports = __webpack_public_path__ + "img/9.15e33748.svg";